import * as React from 'react'
import * as actions from '../../../actions'
import { connect } from 'react-redux'
import { StripeCredentials } from '../../../models/types'
import { Text, Icon, StackChildren } from '@doordash/design-language'
import { IconButton } from '@doordash/component-button'
import { withRouter, RouteComponentProps } from 'react-router'
import { TitleContainer } from './styles'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import t from './strings'
import StripeElements from '../../atoms/stripe-elements'
import StripeCardForm from '../../atoms/stripe-card-form'
import { FastPayModal } from './fast-pay-modal'

type FastPayProps = {
  stripe: any
  uniqueLink: string
}

type ReduxProps = {
  stripeCredentials: StripeCredentials
  dasherId: string
  loadApplicationWebview: (uniqueLink: string) => void
  trackFastPaySetup?: (data: DA.FastPaySetup) => Promise<any>
}

export const FastPay: React.FC<FastPayProps &
  ReduxProps &
  RouteComponentProps> = ({
  uniqueLink,
  dasherId,
  loadApplicationWebview,
  trackFastPaySetup,
}) => {
  const [isShowingModal, setIsShowingModal] = React.useState(false)

  React.useEffect(() => {
    if (!dasherId) {
      const fetchApplication = async () =>
        await loadApplicationWebview(uniqueLink)

      fetchApplication()
      trackFastPaySetup({
        action: DA.EventActions.Rendered,
        name: DA.FastPayNames.FastPayPage,
      })
    }
  }, [dasherId, loadApplicationWebview, trackFastPaySetup, uniqueLink])

  const handleModalClick = (modalName: DA.FastPayNames) => (
    e: React.MouseEvent<HTMLElement>
  ) => {
    e.stopPropagation()

    trackFastPaySetup({
      action: DA.EventActions.Clicked,
      name: modalName,
      value: isShowingModal ? DA.FastPayValues.Closed : DA.FastPayValues.Opened,
    })

    setIsShowingModal(!isShowingModal)
  }

  return (
    <StripeElements dasherId={dasherId}>
      <StackChildren size={StackChildren.Sizes.XxxSmall}>
        <TitleContainer>
          <Text styles={Text.Styles.PageTitle}>{t.title()}</Text>
          <IconButton
            iconType={Icon.Types.InfoCircleLine}
            onClick={handleModalClick(DA.FastPayNames.FastPayInfoModal)}
            accessibilityLabel={t.fastPayInfo__accessibilityLabel()}
          />
        </TitleContainer>
        <Text styles={Text.Styles.PageDescriptionBody}>{t.description()}</Text>
        <StripeCardForm uniqueLink={uniqueLink} dasherId={dasherId} />
        {isShowingModal && (
          <FastPayModal
            onClose={handleModalClick(DA.FastPayNames.FastPayInfoModal)}
          />
        )}
      </StackChildren>
    </StripeElements>
  )
}

const mapStateToProps = state => ({
  stripeCredentials: state.stripeCredentials,
  dasherId: state.dasherId,
})

const mapDispatchToProps = {
  loadApplicationWebview: actions.loadApplicationWebview,
  trackFastPaySetup: events.trackFastPaySetup,
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FastPay))
